/*
    Global Actions Drop down used inside the tables;
*/
import React from 'react';

import { DropdownToggle } from 'reactstrap';

const UpwardActions = (props) => {
   const { children, className, size, ...rest } = props;
   return (
      <DropdownToggle
         className={ `${ className || '' } upward_actions_button btn-light dropdown-toggle text-left` }
         size={size || ''}
         {...rest}
      >
         { children }
         <span className='downArrow ml-2'>
            <i className='fas fa-chevron-down'/>
         </span>
      </DropdownToggle>
   );
};

export default UpwardActions;
